import React, { useState, useEffect, useRef, useImperativeHandle } from "react";
import { searchChatPartners, getPlayerProfile, loadFriends } from "../../actions";
import PlayerItemSmall from "../items/player/small";
import PlayerItemMedium from "../items/player/medium";
import MultiSelect from "../multiSelect";
import { User } from "../../types";
import withRedux from "../../withRedux";
import friendSelector from "../../selectors/friendSelector";
import { formatName } from "../../libs/formatName";

type InputProps = {
	onChange: any;
	preload?: string[];
	loadFriends: any;
	friends: User[];
	input;
};

const PartnersInput = ({ onChange, preload, friends, loadFriends, input }: InputProps) => {
	const [preloaded, setPreloaded] = useState([]);
	const [loading, setLoading] = useState(false);

	const select = useRef<typeof MultiSelect>(null as typeof MultiSelect);

	useImperativeHandle(input, () => ({
		focus: () => {
			if (select.current) {
				//@ts-ignore
				select.current.focus();
			}
		},
	}));

	useEffect(() => {
		if (preload.length > 0) {
			const promises = preload.map(userId => {
				return getPlayerProfile(userId);
			});

			Promise.all(promises).then(results => {
				setPreloaded(results);
				onChange(results);
			});
		}
	}, [preload]);

	useEffect(() => {
		if (friends.length === 0) {
			setLoading(true);
			loadFriends().then(() => {
				setLoading(false);
			});
		}
	}, []);

	const renderOption = (user: User): JSX.Element | JSX.Element[] => {
		return (
			<PlayerItemMedium
				name={formatName(user.firstName, user.lastName)}
				meta={user.city}
				photoUrl={user.photoUrl}
				key={user.userId}
				className="height40"
			/>
		);
	};

	const renderValue = (user: User) => {
		return (
			<PlayerItemSmall
				name={formatName(user.firstName, user.lastName)}
				photoUrl={user.photoUrl}
				key={user.userId}
			/>
		);
	};

	const handleInputChange = async (term: string): Promise<User[]> => {
		if (term.trim() === "") {
			return [];
		}
		return await searchChatPartners(term.trim());
	};

	if (preload.length > 0) {
		return <div>{preloaded.map(renderValue)}</div>;
	} else {
		return (
			<MultiSelect
				onChange={onChange}
				onInputChange={handleInputChange}
				renderOption={renderOption}
				renderValue={renderValue}
				ref={select}
				emptyValue={friendSelector(friends)}
			/>
		);
	}
};

const mapStateToProps = ({ social: { friends } }, ownProps) => {
	return { friends, input: ownProps.input };
};

export default withRedux({ loadFriends }, mapStateToProps)(PartnersInput);
